/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * UIBFS Membership Service API
 * Membership programmes, applications, and category management endpoints.
 * OpenAPI spec version: 1.0.0
 */

export type ChangeApplicationStatusStatus =
  (typeof ChangeApplicationStatusStatus)[keyof typeof ChangeApplicationStatusStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeApplicationStatusStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RENEWED: "RENEWED",
} as const;
